export default "__VITE_ASSET__d48df406__"